import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 45 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M19.0463 3.8627C20.094 0.638119 24.656 0.638122 25.7037 3.86271L28.1859 11.502C28.7883 13.3561 30.5161 14.6115 32.4656 14.6115H40.4981C43.8886 14.6115 45.2983 18.9501 42.5553 20.943L36.0569 25.6644C34.4797 26.8103 33.8198 28.8414 34.4222 30.6955L36.9044 38.3348C37.9521 41.5594 34.2614 44.2409 31.5184 42.248L25.02 37.5266C23.4428 36.3807 21.3072 36.3807 19.73 37.5266L13.2316 42.248C10.4886 44.2409 6.7979 41.5594 7.84563 38.3348L10.3278 30.6955C10.9302 28.8414 10.2703 26.8103 8.69307 25.6644L2.19467 20.943C-0.548325 18.9501 0.861392 14.6115 4.25193 14.6115H12.2844C14.2339 14.6115 15.9617 13.3561 16.5641 11.502L19.0463 3.8627Z",
      fill: "url(#paint0_linear_13016_104947)",
      stroke: "white"
    }, null, -1),
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "paint0_linear_13016_104947",
        x1: "22.375",
        y1: "-8",
        x2: "22.375",
        y2: "56",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", { "stop-color": "#FFEF38" }),
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": "#FAAE3A"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }